import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";
import { useAppSelector } from "../../hooks";
import { format } from "date-fns";

import "./index.css";
import { useEffect, useState } from "react";

interface ScheduledPaymentsProps {
  pageView?: string
  unAuthQbp?: string
}

const ScheduledPayments = ({ pageView, unAuthQbp }: ScheduledPaymentsProps) => {
  const [remainingBalance, setRemainingBalance] = useState<number>(0)
  const dataInstallments = useAppSelector((state) => state.paymentHistoryForPA?.paymentHistory?.treatment);
  const paymentInstallments = dataInstallments?.length ? dataInstallments[0]?.installment : [];

  /*** Utils */
  const formatDate = (date: string = '') => {
    if(!date || Number(date) === 0) return '';

    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);

    if( !(year || month || day) ) return '';

    return format(
      new Date(`${month}/${day}/${year}`), 
      "M/d/yyyy"
    );
  };

  useEffect(() => {
    if (!paymentInstallments?.length) return;

    if (paymentInstallments?.length === 1) {
      setRemainingBalance(paymentInstallments[0]?.status === 'Pending' ? paymentInstallments[0]?.amount : '0.00')
    }

    if (paymentInstallments?.length > 1) {
      const totalBalance = paymentInstallments
        .filter((installment: { status: string }) => installment?.status === 'Pending')
        .reduce((accum:number, curr: {amount:string}) => accum + Number(curr?.amount || 0), 0);
      setRemainingBalance(totalBalance.toFixed(2))
    }
  }, [])

  if (!paymentInstallments?.length) return <></>;

  if (pageView && pageView==="dashboard") {
    return (
      <TableContainer><Table>
        <caption style={{ opacity: "0", position: "absolute" }}>Payment arrangement</caption>
        <TableBody className="tbody">
        {paymentInstallments?.map((installment: any, index: number) => (
          <TableRow key={index}>
            <TableCell className="installment leftside">
              <Typography className="inst-title" component="p">
                {installment.status.toLowerCase() === "paid" 
                  ? `Payment received`
                  : `Installment ${++index}`
                }
              </Typography>
              <Typography className="inst-value bold-600 font-primary" component="p">
                {installment.status.toLowerCase() === "paid" ? `($${installment?.amount})` : `$${installment?.amount} `}
              </Typography>
            </TableCell>

            <TableCell className="installment rightside">
              <Typography className="inst-title" component="p">
                {`Payment date`}
              </Typography>
              <Typography className="inst-value" component="p">
                {formatDate(installment?.date)}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody></Table>
      </TableContainer>
    )
  }

  if (pageView && pageView === 'accountBalance') {
    return (
      <TableContainer className="payment-scheduled" sx={{ width: {md:"536px"}}}>
          <Table>
           <TableHead>
          <TableRow>
            <TableCell className="p-0 border-0" colSpan={2}>
              <Typography className="nonAuthEligibilityModalSubTitleSecond">Payment schedule*</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className="paymentScheduleDetails">
        
        {/* <Box className="paymentScheduleDetails"> */}
          {paymentInstallments?.map((installment: any, index: number) => (
            // <Box key={index} className="DisplayflexofDirectionRowSpaceBetween">
              <TableRow key={index} className="DisplayflexofDirectionRowSpaceBetween1">
              <TableCell className="PartitionSmallSide p-0 border-0" style={{ width: "40%" }}>
                            
                <Typography className="nonAuthEligibilityModalDesc">
                  {installment?.status.toLowerCase() === "paid" 
                    ? `Payment received`
                    : `Installment ${index + 1}`
                  }
                </Typography>
                <Typography className="nonAuthEligibilityModalDate" sx={{ marginBottom: "24px" }}>
                  {formatDate(installment?.date)} 
                </Typography>
                </TableCell>
                <TableCell className="p-0 border-0" sx={{ textAlign: "right", verticalAlign: "top"}}>
              <Typography className="PartitionBigSide1 text-color-secondary">{installment?.status.toLowerCase() === "paid" ? `($${installment?.amount})` : `$${installment?.amount} `}</Typography>
            </TableCell>
            </TableRow>
          ))}
       
       <TableRow className="DisplayflexofDirectionRowSpaceBetweenBottom1 paymentScheduleDetails1">          
          <TableCell className="PartitionSmallSide p-0 border-0" style={{ width: "40%" }}>
            <Typography className="nonAuthEligibilityModalSubTitleSecond">Remaining balance:</Typography>
          </TableCell>
          <TableCell className="p-0 border-0" sx={{ textAlign: "right", verticalAlign: "top"}}>
          <Typography className="nonAuthEligibilityModalSubTitleSecond">{remainingBalance > 0 ? `$${remainingBalance} ` : `$0.00`}</Typography>
          </TableCell>
        </TableRow>
        </TableBody>    
        </Table>    
      </TableContainer>
    );
  }

  return (
    <TableContainer className="payment-scheduled" sx={{ width: {md:"536px"}}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className="p-0 border-0" colSpan={2}>
              <Typography className="nonAuthEligibilityModalSubTitleSecond">Payment schedule*</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className="paymentScheduleDetails">
          {paymentInstallments?.map((installment: any, index: number) => (
            <TableRow key={index} className="DisplayflexofDirectionRowSpaceBetween1">
              <TableCell className="PartitionSmallSide p-0 border-0" style={{ width: "40%" }}>
                <Typography className="nonAuthEligibilityModalDesc">
                  {`Installment ${index + 1}`}
                </Typography>
                <Typography className="nonAuthEligibilityModalDate" sx={{ marginBottom: "24px" }}>
                  {installment?.status.toLowerCase() === "paid"
                    ? `Payment received ${formatDate(installment?.date)}`
                    : formatDate(installment?.date)}
                </Typography>
              </TableCell>
              <TableCell className="p-0 border-0" sx={{ textAlign: "right", verticalAlign: "top"}}>
                <Typography className="text-color-secondary">{installment?.status.toLowerCase() === "paid" ? `($${installment?.amount})` : `$${installment?.amount} `}</Typography>
              </TableCell>
            </TableRow>
          ))}
          <TableRow className="DisplayflexofDirectionRowSpaceBetweenBottom1 paymentScheduleDetails1">
            <TableCell className="PartitionSmallSide p-0 border-0" style={{ width: "40%" }}>
              <Typography className="nonAuthEligibilityModalSubTitleSecond">Remaining balance:</Typography>
            </TableCell>
            <TableCell className="p-0 border-0" sx={{ textAlign: "right", verticalAlign: "top"}}>
              <Typography className="nonAuthEligibilityModalSubTitleSecond">{remainingBalance > 0 ? `$${remainingBalance} ` : `$0.00`}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ScheduledPayments;